import { storeBalanceZones, storeCompanies, storeLogoutHandler, storeUser } from '../redux'
import { fetchBalanceZones, fetchCompanies } from '.'
import { ApiRBAC } from '../api/RBAC/rbac.api'

const apiRBAC = new ApiRBAC()

export const fetchUser = async (logoutHandler: () => void): Promise<boolean> => {
  storeLogoutHandler(logoutHandler)

  return await apiRBAC
    .fetch()
    .then(async user => {
      if (user === null) {
        return false
      }
      storeUser(user)
      try {
        const companies = await fetchCompanies()
        storeCompanies(companies)
        try {
          const balanceZones = await fetchBalanceZones()
          storeBalanceZones(balanceZones)

          return true
        } catch (error) {
          return false
        }
      } catch (error) {
        return false
      }
    })
    .catch(error => {
      return false
    })
}
